const colLinks = [
  { title: "栏目", links: ["今日头瓜", "话题热墙", "热度榜", "独家放料", "每日看点"] },
  { title: "站内", links: ["关于我们", "编辑部", "合作爆料", "投稿入口", "意见反馈"] },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-300/60 bg-background-100/70 md:mt-20">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* brand block */}
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-serif text-2xl font-black text-background-50">
                5
              </span>
              <span className="font-serif text-2xl font-black text-foreground-950">吃瓜网</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              5吃瓜网每日更新爆料与独家内幕，猛料不断。想看黑料、内幕、独家消息，点开即看，满足你的吃瓜好奇心，热门事件一网打尽。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              {["独家", "内幕", "黑料", "猛料"].map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center rounded-full bg-background-200/70 px-2.5 py-0.5 text-xs text-foreground-600"
                >
                  #{t}
                </span>
              ))}
            </div>
          </div>

          {/* link columns */}
          {colLinks.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <p className="text-sm font-semibold text-foreground-900">{col.title}</p>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#top"
                      className="inline-flex whitespace-nowrap text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* about block */}
          <div className="lg:col-span-3">
            <p className="text-sm font-semibold text-foreground-900">把瓜递给我</p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-500">
              有独家线索？留个码，我们 24 小时内回你。
            </p>
            <a
              href="#note"
              className="mt-4 inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-line text-base w-4 h-4 flex items-center justify-center" />
              匿名爆料
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-400 font-label">
            © 2026 5吃瓜网 · 本页为单页演示，内容仅供娱乐，不做事实依据。
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-400 font-label">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-fire-fill text-primary-600 w-3.5 h-3.5 flex items-center justify-center" />
              吃瓜热度仍在上涨
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center" />
              下一波更新 23:00
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}